module.exports = __webpack_public_path__ + "img/tx.94f40cb7.jpeg";